import { RowBase, RowChoiceProps } from "./RowBase";

export function RowNoInput({ answer }: RowChoiceProps) {
    return <RowBase question={answer.question} />;
}
